import React, { useState } from "react";
import Input from "antd/es/input/Input";
import Loader from "../loader/loader";
import { Button, Row, Col, Typography, Select } from "antd";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import { GreenNotify, RedNotify } from "../../helper/helper";
import { useNavigate } from "react-router-dom";

const NEWS_CATEGORIES = [
  "Tech",
  "Music",
  "Automobiles",
  "News",
  "Sports",
  "Gadgets",
];

const NewPreference = () => {
  const [isloading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [type, setType] = useState("");
  const [newsCategories, setNewsCategories] = useState([]);

  const createPreference = () => {
    if (!title || !type) {
      RedNotify("Please fill all the fields");
      return;
    }

    let body = { title, type, newsCategories: newsCategories || [] };

    let getRes = (res) => {
      GreenNotify("Preference is created successfully");
      navigate("/preference");
    };

    callApi(
      "POST",
      routes.createPreference,
      body,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      },
    );
  };

  return (
    <>
      <div style={{ marginBottom: "2rem", padding: "3rem" }}>
        <Loader loading={isloading} />
        <h2>Create Preference</h2>
        <Row gutter={32} style={{ marginTop: "2rem" }}>
          <Col xs={24} sm={24} md={8}>
            <Typography.Title level={5}>Title</Typography.Title>
            <Input
              style={{
                marginTop: "1rem",
                height: "3.5rem",
                fontSize: "1.5rem",
                width: "100%",
              }}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Title"
            />
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Typography.Title level={5}>Type</Typography.Title>
            <Input
              style={{
                marginTop: "1rem",
                height: "3.5rem",
                fontSize: "1.5rem",
                width: "100%",
              }}
              value={type}
              onChange={(e) => setType(e.target.value)}
              placeholder="Type"
            />
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Typography.Title level={5}>News categories</Typography.Title>
            <Select
              mode="multiple"
              allowClear
              placeholder="Select news categories (for AI posts)"
              value={newsCategories}
              onChange={setNewsCategories}
              options={NEWS_CATEGORIES.map((c) => ({ label: c, value: c }))}
              style={{
                marginTop: "1rem",
                width: "100%",
              }}
            />
          </Col>
        </Row>
      </div>
      <Button
        type="primary"
        style={{ marginLeft: "3rem" }}
        onClick={createPreference}
      >
        Create
      </Button>
    </>
  );
};

export default NewPreference;
